export default function Dashboard() {
  return (
    <>
      <p>This is the Admin Home Page</p>

      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam non magna
        nisi. Curabitur vehicula ipsum sit amet diam commodo, in ullamcorper
        lectus dictum. Etiam scelerisque felis hendrerit convallis commodo.
        Etiam ut tellus quis nisi rhoncus semper. Quisque ultricies ullamcorper
        ex, sed ullamcorper urna placerat quis. Suspendisse rhoncus vehicula
        urna quis efficitur. Proin condimentum dui non lobortis scelerisque.
        Fusce fringilla ullamcorper enim ac facilisis. Vivamus quis quam elit.
        In hac habitasse platea dictumst. Nullam et dui eros. Nullam posuere
        quam eget elementum interdum. Donec sit amet ligula ut ex aliquet
        venenatis.
      </p>
      <p>
        Praesent sed sagittis odio. Maecenas vel leo suscipit mauris aliquet
        cursus. Pellentesque id semper arcu. Mauris lorem velit, scelerisque in
        lorem ac, tempor semper ex. In ornare auctor lacinia. Aliquam eleifend a
        nibh at convallis. Nam fringilla est a sem vulputate, sit amet laoreet
        lacus dapibus.
      </p>
      <p>
        Suspendisse fermentum nulla in velit venenatis, fringilla varius magna
        varius. Pellentesque sed vestibulum dolor. Duis convallis fringilla
        aliquet. Aenean vestibulum leo id orci venenatis pharetra. Mauris
        molestie orci vitae interdum rutrum. Sed iaculis, nibh eget molestie
        imperdiet, urna eros tincidunt erat, nec dignissim orci leo sit amet
        nisl. In eleifend odio in augue feugiat, sed pulvinar purus porta.
        Maecenas urna dolor, fermentum dapibus nisl ut, placerat scelerisque
        felis. Sed lorem nibh, egestas in tortor et, aliquam semper arcu. Morbi
        dictum euismod posuere. Nullam quis convallis arcu. Pellentesque vitae
        posuere justo. Morbi convallis sapien a nulla vulputate, consequat
        fermentum enim volutpat.
      </p>
      <p>
        Morbi posuere dolor et sagittis gravida. Sed sit amet volutpat neque,
        gravida euismod ipsum. Phasellus tempor ex dui, nec semper purus dictum
        vitae. Orci varius natoque penatibus et magnis dis parturient montes,
        nascetur ridiculus mus. Duis at mi dui. Fusce feugiat justo velit,
        egestas dictum ante scelerisque sit amet. Proin in ex ut ipsum cursus
        varius. Sed ut turpis nisl. Morbi ac varius turpis, ut gravida ex. Cras
        egestas bibendum hendrerit. Proin tincidunt eu lectus vitae semper.
        Quisque ut quam ut orci euismod interdum nec sed sapien. Nullam vel
        rutrum mauris. Mauris blandit nibh non commodo consequat. Integer
        interdum mollis mi, ac vehicula ipsum dictum et.
      </p>
      <p>
        Donec mattis massa ut tempor blandit. Nullam vehicula faucibus ipsum,
        sed pellentesque turpis elementum ac. Nullam ultricies ut sem finibus
        malesuada. Fusce ac nibh vitae ipsum aliquam euismod. Phasellus lobortis
        metus id massa fermentum, vitae aliquet eros facilisis. Nunc interdum
        sapien sed malesuada malesuada. Interdum et malesuada fames ac ante
        ipsum primis in faucibus.
      </p>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam non magna
        nisi. Curabitur vehicula ipsum sit amet diam commodo, in ullamcorper
        lectus dictum. Etiam scelerisque felis hendrerit convallis commodo.
        Etiam ut tellus quis nisi rhoncus semper. Quisque ultricies ullamcorper
        ex, sed ullamcorper urna placerat quis. Suspendisse rhoncus vehicula
        urna quis efficitur. Proin condimentum dui non lobortis scelerisque.
        Fusce fringilla ullamcorper enim ac facilisis. Vivamus quis quam elit.
        In hac habitasse platea dictumst. Nullam et dui eros. Nullam posuere
        quam eget elementum interdum. Donec sit amet ligula ut ex aliquet
        venenatis.
      </p>
      <p>
        Praesent sed sagittis odio. Maecenas vel leo suscipit mauris aliquet
        cursus. Pellentesque id semper arcu. Mauris lorem velit, scelerisque in
        lorem ac, tempor semper ex. In ornare auctor lacinia. Aliquam eleifend a
        nibh at convallis. Nam fringilla est a sem vulputate, sit amet laoreet
        lacus dapibus.
      </p>
      <p>
        Suspendisse fermentum nulla in velit venenatis, fringilla varius magna
        varius. Pellentesque sed vestibulum dolor. Duis convallis fringilla
        aliquet. Aenean vestibulum leo id orci venenatis pharetra. Mauris
        molestie orci vitae interdum rutrum. Sed iaculis, nibh eget molestie
        imperdiet, urna eros tincidunt erat, nec dignissim orci leo sit amet
        nisl. In eleifend odio in augue feugiat, sed pulvinar purus porta.
        Maecenas urna dolor, fermentum dapibus nisl ut, placerat scelerisque
        felis. Sed lorem nibh, egestas in tortor et, aliquam semper arcu. Morbi
        dictum euismod posuere. Nullam quis convallis arcu. Pellentesque vitae
        posuere justo. Morbi convallis sapien a nulla vulputate, consequat
        fermentum enim volutpat.
      </p>
      <p>
        Morbi posuere dolor et sagittis gravida. Sed sit amet volutpat neque,
        gravida euismod ipsum. Phasellus tempor ex dui, nec semper purus dictum
        vitae. Orci varius natoque penatibus et magnis dis parturient montes,
        nascetur ridiculus mus. Duis at mi dui. Fusce feugiat justo velit,
        egestas dictum ante scelerisque sit amet. Proin in ex ut ipsum cursus
        varius. Sed ut turpis nisl. Morbi ac varius turpis, ut gravida ex. Cras
        egestas bibendum hendrerit. Proin tincidunt eu lectus vitae semper.
        Quisque ut quam ut orci euismod interdum nec sed sapien. Nullam vel
        rutrum mauris. Mauris blandit nibh non commodo consequat. Integer
        interdum mollis mi, ac vehicula ipsum dictum et.
      </p>
      <p>
        Donec mattis massa ut tempor blandit. Nullam vehicula faucibus ipsum,
        sed pellentesque turpis elementum ac. Nullam ultricies ut sem finibus
        malesuada. Fusce ac nibh vitae ipsum aliquam euismod. Phasellus lobortis
        metus id massa fermentum, vitae aliquet eros facilisis. Nunc interdum
        sapien sed malesuada malesuada. Interdum et malesuada fames ac ante
        ipsum primis in faucibus.
      </p>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam non magna
        nisi. Curabitur vehicula ipsum sit amet diam commodo, in ullamcorper
        lectus dictum. Etiam scelerisque felis hendrerit convallis commodo.
        Etiam ut tellus quis nisi rhoncus semper. Quisque ultricies ullamcorper
        ex, sed ullamcorper urna placerat quis. Suspendisse rhoncus vehicula
        urna quis efficitur. Proin condimentum dui non lobortis scelerisque.
        Fusce fringilla ullamcorper enim ac facilisis. Vivamus quis quam elit.
        In hac habitasse platea dictumst. Nullam et dui eros. Nullam posuere
        quam eget elementum interdum. Donec sit amet ligula ut ex aliquet
        venenatis.
      </p>
      <p>
        Praesent sed sagittis odio. Maecenas vel leo suscipit mauris aliquet
        cursus. Pellentesque id semper arcu. Mauris lorem velit, scelerisque in
        lorem ac, tempor semper ex. In ornare auctor lacinia. Aliquam eleifend a
        nibh at convallis. Nam fringilla est a sem vulputate, sit amet laoreet
        lacus dapibus.
      </p>
      <p>
        Suspendisse fermentum nulla in velit venenatis, fringilla varius magna
        varius. Pellentesque sed vestibulum dolor. Duis convallis fringilla
        aliquet. Aenean vestibulum leo id orci venenatis pharetra. Mauris
        molestie orci vitae interdum rutrum. Sed iaculis, nibh eget molestie
        imperdiet, urna eros tincidunt erat, nec dignissim orci leo sit amet
        nisl. In eleifend odio in augue feugiat, sed pulvinar purus porta.
        Maecenas urna dolor, fermentum dapibus nisl ut, placerat scelerisque
        felis. Sed lorem nibh, egestas in tortor et, aliquam semper arcu. Morbi
        dictum euismod posuere. Nullam quis convallis arcu. Pellentesque vitae
        posuere justo. Morbi convallis sapien a nulla vulputate, consequat
        fermentum enim volutpat.
      </p>
      <p>
        Morbi posuere dolor et sagittis gravida. Sed sit amet volutpat neque,
        gravida euismod ipsum. Phasellus tempor ex dui, nec semper purus dictum
        vitae. Orci varius natoque penatibus et magnis dis parturient montes,
        nascetur ridiculus mus. Duis at mi dui. Fusce feugiat justo velit,
        egestas dictum ante scelerisque sit amet. Proin in ex ut ipsum cursus
        varius. Sed ut turpis nisl. Morbi ac varius turpis, ut gravida ex. Cras
        egestas bibendum hendrerit. Proin tincidunt eu lectus vitae semper.
        Quisque ut quam ut orci euismod interdum nec sed sapien. Nullam vel
        rutrum mauris. Mauris blandit nibh non commodo consequat. Integer
        interdum mollis mi, ac vehicula ipsum dictum et.
      </p>
      <p>
        Donec mattis massa ut tempor blandit. Nullam vehicula faucibus ipsum,
        sed pellentesque turpis elementum ac. Nullam ultricies ut sem finibus
        malesuada. Fusce ac nibh vitae ipsum aliquam euismod. Phasellus lobortis
        metus id massa fermentum, vitae aliquet eros facilisis. Nunc interdum
        sapien sed malesuada malesuada. Interdum et malesuada fames ac ante
        ipsum primis in faucibus.
      </p>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam non magna
        nisi. Curabitur vehicula ipsum sit amet diam commodo, in ullamcorper
        lectus dictum. Etiam scelerisque felis hendrerit convallis commodo.
        Etiam ut tellus quis nisi rhoncus semper. Quisque ultricies ullamcorper
        ex, sed ullamcorper urna placerat quis. Suspendisse rhoncus vehicula
        urna quis efficitur. Proin condimentum dui non lobortis scelerisque.
        Fusce fringilla ullamcorper enim ac facilisis. Vivamus quis quam elit.
        In hac habitasse platea dictumst. Nullam et dui eros. Nullam posuere
        quam eget elementum interdum. Donec sit amet ligula ut ex aliquet
        venenatis.
      </p>
      <p>
        Praesent sed sagittis odio. Maecenas vel leo suscipit mauris aliquet
        cursus. Pellentesque id semper arcu. Mauris lorem velit, scelerisque in
        lorem ac, tempor semper ex. In ornare auctor lacinia. Aliquam eleifend a
        nibh at convallis. Nam fringilla est a sem vulputate, sit amet laoreet
        lacus dapibus.
      </p>
      <p>
        Suspendisse fermentum nulla in velit venenatis, fringilla varius magna
        varius. Pellentesque sed vestibulum dolor. Duis convallis fringilla
        aliquet. Aenean vestibulum leo id orci venenatis pharetra. Mauris
        molestie orci vitae interdum rutrum. Sed iaculis, nibh eget molestie
        imperdiet, urna eros tincidunt erat, nec dignissim orci leo sit amet
        nisl. In eleifend odio in augue feugiat, sed pulvinar purus porta.
        Maecenas urna dolor, fermentum dapibus nisl ut, placerat scelerisque
        felis. Sed lorem nibh, egestas in tortor et, aliquam semper arcu. Morbi
        dictum euismod posuere. Nullam quis convallis arcu. Pellentesque vitae
        posuere justo. Morbi convallis sapien a nulla vulputate, consequat
        fermentum enim volutpat.
      </p>
      <p>
        Morbi posuere dolor et sagittis gravida. Sed sit amet volutpat neque,
        gravida euismod ipsum. Phasellus tempor ex dui, nec semper purus dictum
        vitae. Orci varius natoque penatibus et magnis dis parturient montes,
        nascetur ridiculus mus. Duis at mi dui. Fusce feugiat justo velit,
        egestas dictum ante scelerisque sit amet. Proin in ex ut ipsum cursus
        varius. Sed ut turpis nisl. Morbi ac varius turpis, ut gravida ex. Cras
        egestas bibendum hendrerit. Proin tincidunt eu lectus vitae semper.
        Quisque ut quam ut orci euismod interdum nec sed sapien. Nullam vel
        rutrum mauris. Mauris blandit nibh non commodo consequat. Integer
        interdum mollis mi, ac vehicula ipsum dictum et.
      </p>
      <p>
        Donec mattis massa ut tempor blandit. Nullam vehicula faucibus ipsum,
        sed pellentesque turpis elementum ac. Nullam ultricies ut sem finibus
        malesuada. Fusce ac nibh vitae ipsum aliquam euismod. Phasellus lobortis
        metus id massa fermentum, vitae aliquet eros facilisis. Nunc interdum
        sapien sed malesuada malesuada. Interdum et malesuada fames ac ante
        ipsum primis in faucibus.
      </p>
    </>
  );
}
